<template>
  <div class="facet-checkbox">
    <label :class="{ disabled }">
      <input
        type="checkbox"
        :checked="modelValue"
        :disabled="disabled"
        :name="name"
        @change="onChange"
      />
      <span class="checkbox-tick" />
      <slot />
    </label>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  modelValue: boolean
  name?: string
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

function onChange(event: Event) {
  const checked = (event.target as HTMLInputElement).checked
  emit('update:modelValue', checked)
}
</script>

<style scoped>
label {
  align-items: center;
  cursor: pointer;
  display: flex !important;
  flex-direction: row;
  font-size: var(--body);
  font-weight: normal;
  justify-content: flex-start;
  margin-bottom: 0.5em;
  position: relative;
}

input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.checkbox-tick {
  border-radius: 0.2em;
  height: 1.6em;
  width: 1.6em;
  flex-shrink: 0;
  background-color: #eee;
  border: 1px solid var(--colour-light-grey);
  margin-right: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.checkbox-tick:after {
  content: '';
  position: absolute;
  display: none;
  visibility: hidden;
  width: 0.6em;
  height: 1em;
  border: solid white;
  border-width: 0 0.2em 0.2em 0;
  transform: translateY(-0.1em) rotate(45deg);
}

input:checked ~ .checkbox-tick:after {
  display: block;
  visibility: visible;
}

input:checked ~ .checkbox-tick {
  background-color: var(--colour-header-dark-blue);
  border-color: var(--colour-header-dark-blue);
}

label.disabled {
  color: #bbb;
  pointer-events: none;
  cursor: not-allowed;
}

input:disabled ~ .checkbox-tick {
  background-color: #eee;
  border-color: #ddd;
  cursor: not-allowed;
}

input:disabled ~ .checkbox-tick:after {
  border-color: var(--colour-table-borders);
}

@media (hover: hover) {
  label:hover input ~ .checkbox-tick {
    background-color: var(--colour-page-background);
    border-color: var(--colour-header-dark-blue);
    box-shadow: 0 0 0 2px var(--colour-header-dark-blue);
  }

  label:hover input:not([disabled]):checked ~ .checkbox-tick {
    background-color: var(--colour-dark-blue);
    border-color: var(--colour-dark-blue);
    box-shadow: none;
  }
}
</style>
